import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { RbacClient, rbacApiRef } from './api/RbacApi';

export const rbacPlugin = createPlugin({
  id: 'rbac',
  routes: { root: rootRouteRef },
  apis: [
    createApiFactory({
      api: rbacApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new RbacClient({ discoveryApi, fetchApi }),
    }),
  ],
});

/** Roles, members and permissions. Mounted at /rbac. */
export const RbacPage = rbacPlugin.provide(
  createRoutableExtension({
    name: 'RbacPage',
    component: () => import('./components/RbacPage').then(m => m.RbacPage),
    mountPoint: rootRouteRef,
  }),
);
